import redaxios from 'redaxios';

const connObj = process.env.REACT_APP_ENVIRONMENT==='development' ? 
  {baseURL: `${process.env.REACT_APP_NGINX_HOST}:${process.env.REACT_APP_NGINX_PORT}`,
  } : {};

export default redaxios.create(connObj);
